export default "__VITE_ASSET__DJIbEN9z__"